module.exports = __webpack_public_path__ + "static/media/placeholder-program-carousel.9bf1c30f.png";